import { ClassNames } from '@emotion/react'
import Section from '../components/section'
import { cx } from '@/utils/strings'

type RecommendationsProps = {
  heading: string
  items: {
    src: string
    alt: string
    widthMobile: number
    widthDesktop: number
  }[]
}

export default function Recommendations({ heading, items = [] }: RecommendationsProps) {
  return (
    <ClassNames>
      {({ css }) => (
        <Section className="text-center">
          <h2 className="text-4xl mb-6">{heading}</h2>
          <div className="w-full flex items-center justify-center gap-7 flex-wrap md:gap-10 md:flex-nowrap">
            {items.map((item, i) => (
              <img
                key={i}
                src={item.src}
                alt={item.alt}
                className={cx(
                  'shrink',
                  css`
                    width: ${item.widthMobile}px;

                    @media (min-width: 768px) {
                      width: ${item.widthDesktop}px;
                    }
                  `
                )}
              />
            ))}
          </div>
        </Section>
      )}
    </ClassNames>
  )
}
